import { z } from "zod";
export var DmaIngredientKind;
(function (DmaIngredientKind) {
    DmaIngredientKind["Compound"] = "Compound";
    DmaIngredientKind["Mixture"] = "Mixture";
    DmaIngredientKind["Micelle"] = "Micelle";
})(DmaIngredientKind || (DmaIngredientKind = {}));
export const dmaIngredientKindDtoSchema = z.nativeEnum(DmaIngredientKind);
